import { useEffect } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { engine } from "./engine/MTProtoEngine";
import { useEngineStore } from "./store/useEngineStore";
import { useJobStore } from "./store/useJobStore";
import { cn } from "./ui";

const nav = [
  { to: "/setup", label: "Configuración" },
  { to: "/groups", label: "Grupos & Tags" },
  { to: "/compose", label: "Redactar" },
  { to: "/cupon", label: "Cupón" },
  { to: "/send", label: "Enviar" },
];

export function App() {
  const loc = useLocation();
  const phase = useEngineStore((s) => s.phase);
  const me = useEngineStore((s) => s.me);
  const jobStatus = useJobStore((s) => s.status);

  useEffect(() => {
    engine.init();
  }, []);

  const running = jobStatus === "running";

  return (
    <div className="flex min-h-screen flex-col">
      <header className="border-b border-slate-800 bg-slate-950/80 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center gap-6 px-4 py-3">
          <span className="text-sm font-semibold tracking-tight text-sky-400">TG&nbsp;Broadcast</span>
          <nav className="flex gap-1">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  cn(
                    "rounded-md px-3 py-1.5 text-sm",
                    isActive || loc.pathname === n.to
                      ? "bg-slate-800 text-white"
                      : "text-slate-400 hover:text-slate-200",
                  )
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-2 text-xs">
            <span
              className={cn(
                "h-2 w-2 rounded-full",
                phase === "connected" ? "bg-emerald-500" : "bg-slate-600",
              )}
            />
            <span className="text-slate-400">
              {phase === "connected" ? `@${me?.username ?? me?.firstName ?? "conectado"}` : "sin sesión"}
            </span>
          </div>
        </div>
        {running && (
          <div className="bg-amber-900/60 px-4 py-1.5 text-center text-xs text-amber-200">
            ⚠ Envío en curso — mantén esta pestaña abierta y el equipo encendido.
          </div>
        )}
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
